'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierInteraction(traits) {
    return (0, _track2.default)(_events.EVENT_BARRIER_INTERACTION, (0, _extends3.default)({}, traits), {}, false, true, true);
}

exports.default = trackBarrierInteraction;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/trackBarrierInteraction.js
// module id = 2706
// module chunks = 0